import { useOutletContext } from "react-router-dom";
import { OutletContextType, schooYearType } from "../../types/GlobalType";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  schoolController,
  schoolYearController,
} from "../../_api/controllers/scolarite.controller.ts";
import { useState } from "react";

const General: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  const [notification, setNotification] = useState<any>(null); // { message, type }
  // Fonction pour afficher une notification

  const showNotification = (message: string, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  const queryClient = useQueryClient();

  //fetch anne scolaire
  const { data: schoolYearData } = useQuery({
    queryKey: ["schoolYears"],
    queryFn: schoolYearController.getAll,
  });

  //fetch school identity
  const { data: schoolData } = useQuery({
    queryKey: ["school"],
    queryFn: schoolController.getAll,
  });

  const schoolYearArr = schoolYearData?.data || [];
  const schoolArr = schoolData?.data || [];
  // const schoolYearActiveDataArr = schoolYearActiveData?.data || [];

  const [selectedYearData, setSelectedYearData] = useState<schooYearType | any>(
    null
  );

  const mutationSaveSelectedYear = useMutation({
    mutationFn: () => schoolYearController.selectYear(selectedYearData.id),
    onSuccess: () => {
      showNotification("Modification effectuée avec succès!", "success");
      setSelectedYearData(null);
      queryClient.invalidateQueries({ queryKey: ["schoolYears"] });
    },

    onError: (err) => {
      console.log(err);
      showNotification("Une erreur est survenue, réessayer.", "erreur");
    },
  });

  // console.log(selectedYearData);
  const handleSave = () => {
    //logic to save general settings
    mutationSaveSelectedYear.mutate();
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Paramètres généraux</h2>
      <p className={`mb-6 ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
        Configurez les paramètres de base de Chiksoft
      </p>
      <div className="space-y-6">
        <div
          className={`p-4 rounded-lg border ${
            isDarkMode
              ? "bg-[#0D1117] border-gray-700"
              : "bg-gray-50 border-gray-200"
          }`}
        >
          <h3 className="text-lg font-medium mb-4">
            Informations de l'établissement
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Nom de l'établissement
              </label>
              <input
                type="text"
                value={schoolArr[0]?.designation || ""}
                // defaultValue={schoolArr[0]?.designation || ""}
                className={`w-full px-3 py-2 rounded-md border ${
                  isDarkMode
                    ? "bg-[#161B22] border-gray-700"
                    : "bg-white border-gray-300"
                } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                readOnly
              />
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Type d'établissement
              </label>
              <div
                className={`relative border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                } rounded-md`}
              >
                <select
                  className={`appearance-none w-full px-3 rounded-md ${
                    isDarkMode ? "bg-[#161B22]" : "bg-white"
                  } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                >
                  {/* <option value="college">Collège</option>
                          <option value="lycee">Lycée</option>
                          <option value="primaire">École primaire</option> */}
                  <option value="secondaire">École secondaire</option>
                  {/* <option value="maternelle">École maternelle</option> */}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                  <i className="fas fa-chevron-down"></i>
                </div>
              </div>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Code
              </label>
              <input
                readOnly
                type="text"
                value={schoolArr[0]?.code || ""}
                defaultValue={schoolArr[0]?.code || ""}
                className={`w-full px-3 py-2 rounded-md border ${
                  isDarkMode
                    ? "bg-[#161B22] border-gray-700"
                    : "bg-white border-gray-300"
                } focus:outline-none focus:ring-2 focus:ring-blue-500`}
              />
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Ville
              </label>
              <input
                readOnly
                type="text"
                value={"Goma"}
                // defaultValue="Goma"
                className={`w-full px-3 py-2 rounded-md border ${
                  isDarkMode
                    ? "bg-[#161B22] border-gray-700"
                    : "bg-white border-gray-300"
                } focus:outline-none focus:ring-2 focus:ring-blue-500`}
              />
            </div>
            {/* <div>
                      <label
                        className={`block text-sm font-medium mb-1 ${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        }`}
                      >
                        Code postal
                      </label>
                      <input
                        type="text"
                        defaultValue="75015"
                        className={`w-full px-3 py-2 rounded-md border ${
                          isDarkMode
                            ? "bg-[#161B22] border-gray-700"
                            : "bg-white border-gray-300"
                        } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      />
                    </div>
                    <div>
                      <label
                        className={`block text-sm font-medium mb-1 ${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        }`}
                      >
                        Téléphone
                      </label>
                      <input
                        type="text"
                        defaultValue="01 23 45 67 89"
                        className={`w-full px-3 py-2 rounded-md border ${
                          isDarkMode
                            ? "bg-[#161B22] border-gray-700"
                            : "bg-white border-gray-300"
                        } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      />
                    </div> */}
          </div>
        </div>
        <div
          className={`p-4 rounded-lg border ${
            isDarkMode
              ? "bg-[#0D1117] border-gray-700"
              : "bg-gray-50 border-gray-200"
          }`}
        >
          <h3 className="text-lg font-medium mb-4">Année scolaire</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Activer une année scolaire
              </label>
              <div
                className={`relative border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                } rounded-md`}
              >
                <select
                  className={`appearance-none w-full px-3 h-10 rounded-md ${
                    isDarkMode ? "bg-[#161B22]" : "bg-white"
                  } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (!value) {
                      setSelectedYearData(null);
                      return;
                    }
                    const obj = JSON.parse(value);
                    setSelectedYearData(obj);
                  }}
                  // defaultValue={selectedYearData}
                >
                  {<option value={""}>selectionner une année scolaire</option>}
                  {schoolYearArr.map((yearItem: any) => {
                    return (
                      <option
                        selected={yearItem.selected ? true : false}
                        key={yearItem.id}
                        value={JSON.stringify(yearItem)}
                      >
                        {yearItem.designation}
                      </option>
                    );
                  })}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                  <i className="fas fa-chevron-down"></i>
                </div>
              </div>
            </div>
            <div className="flex flex-col flex-1">
              <label
                className={`block text-sm font-medium mb-1 ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Date de début
              </label>

              <span
                className={`w-full px-3 py-2 rounded-md border ${
                  isDarkMode
                    ? "bg-[#161B22] border-gray-700"
                    : "bg-white border-gray-300"
                } focus:outline-none focus:ring-2 focus:ring-blue-500`}
              >
                {selectedYearData?.date_debut || "2000-01-01"}
              </span>
            </div>
            <div className="flex flex-col flex-1">
              <label
                className={`block text-sm font-medium mb-1 ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Date de fin
              </label>
              <span
                className={`w-full px-3 py-2 rounded-md border ${
                  isDarkMode
                    ? "bg-[#161B22] border-gray-700"
                    : "bg-white border-gray-300"
                } focus:outline-none focus:ring-2 focus:ring-blue-500`}
              >
                {selectedYearData?.date_fin || "2000-01-01"}
              </span>
            </div>
          </div>
          <div className="mt-4">
            <label
              className={`flex items-center ${
                isDarkMode ? "text-gray-300" : "text-gray-700"
              }`}
            >
              <input
                type="checkbox"
                defaultChecked={true}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-sm">
                Autoriser l'accès aux années précédentes
              </span>
            </label>
          </div>
        </div>
      </div>
      <div className="mt-6 flex justify-end space-x-3">
        {/* <button
          disabled={mutationSaveSelectedYear.isPending}
          className={`px-4 py-2 rounded-md ${
            isDarkMode
              ? "bg-gray-700 hover:bg-gray-600"
              : "bg-gray-200 hover:bg-gray-300"
          } !rounded-button whitespace-nowrap ${
            mutationSaveSelectedYear.isPending
              ? "cursor-not-allowed opacity-50"
              : ""
          }`}
        >
          Annuler
        </button> */}
        <button
          disabled={mutationSaveSelectedYear.isPending || !selectedYearData}
          onClick={() => {
            handleSave();
          }}
          className={`px-4 py-2 rounded-md ${
            isDarkMode
              ? "bg-blue-600 hover:bg-blue-700"
              : "bg-blue-500 hover:bg-blue-600"
          } text-white !rounded-button whitespace-nowrap ${
            mutationSaveSelectedYear.isPending || !selectedYearData
              ? "cursor-not-allowed opacity-50"
              : ""
          }`}
        >
          {mutationSaveSelectedYear.isPending
            ? "Enregistrement en cours..."
            : "Enregistrer les modifications"}
        </button>
      </div>

      {/* ===== NOTIFICATION ===== */}
      {notification && (
        <div
          className={`fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white shadow-lg transition-all duration-500 ${
            notification.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {notification.message}
        </div>
      )}
    </div>
  );
};

export default General;
